import { checkDraftVesselCall } from "@services/vesselCallApi";
import type { NavigateFunction } from "react-router-dom";
import type { VesselScanItem } from "./VesselScanResults.types";

export const handleSingleVesselRedirect = async (
  vessel: VesselScanItem,
  navigate: NavigateFunction,
) => {
  const response = await checkDraftVesselCall(vessel.id);

  if (response?.vesselCallId) {
    navigate(`/vessel-call/vessel-call-status/${response.vesselCallId}`, {
      state: { vessel },
    });
    return;
  }

  navigate("/vessel-call/create", { state: { vessel } });
};

export const hasAlreadyActiveVesselCall = (error: any): boolean => {
  const statusCode = error?.response?.status;
  if (statusCode !== 400) {
    return false;
  }

  return (
    error?.response?.data?.detail === "There is already an active vessel call for this vessel."
  );
};
